import { useParams } from '@tanstack/react-router';

import { Text } from '../../../cdl/Text/Text';
import { translate } from '../../../common/helpers/translate.helper';
import { Box } from '../../../common/ui/Box';
import { CompanyOverviewPage } from '../../components/CompanyOverviewPage';
import { SupplierGroupPlanSection } from '../detail/components/SupplierGroupPlanSection';
import { SuppliersTable } from '../detail/components/SuppliersTable';

export const SupplierCompaniesPage = () => {
    const { groupId } = useParams({ from: '/_app/supplier-groups/$groupId/companies' });

    return (
        <CompanyOverviewPage>
            <SupplierGroupPlanSection supplierGroupId={groupId} />
            <Box display="flex" flexDirection="column" gap={16}>
                <Text variant="subtitle1" as="h2">
                    {translate('suppliers.subheadline')}
                </Text>
                <SuppliersTable groupId={groupId} />
            </Box>
        </CompanyOverviewPage>
    );
};
